<template>
    <li class="tender-item">
        <div class="tender-item__header">
            <b>Закупка:</b> 
            <a v-if="tender.purchase_number" :href="getLink(tender.tender_law, tender.purchase_number)" target="_blank">{{tender.purchase_number}}</a>
            <b v-else>Б/Н</b> 
            <b>от {{dateParser(tender.date)}}</b> 
            <span class="grey">({{tender.tender_law}}-ФЗ)</span>
        </div>
        <p v-if="tender.title" class="tender-item__description"><b>{{tender.title}}</b></p>
        <div v-if="tender.customers.length" class="tender-item__customers">
            <template v-if="tender.customers.length > 1">
                <b>Заказчики:</b>
                <ul class="small-list">
                    <li v-for="(c, i) in tender.customers" :key="i">
                        <span v-if="c.ogrn || c.inn">
                            <card-link :ogrn="c.ogrn || c.inn">{{c.name}}</card-link> 
                            <tooltip class="stay-on-row" :ogrn="c.ogrn || c.inn" />
                        </span>
                        <span v-else>{{c.name}}</span>
                    </li>
                </ul>
            </template>
            <span v-else>
                <b>Заказчик:</b>
                <template v-if="tender.customers[0].ogrn || tender.customers[0].inn">
                    <card-link :ogrn="tender.customers[0].ogrn || tender.customers[0].inn">
                        {{tender.customers[0].name}}
                    </card-link>
                    <tooltip class="stay-on-row" :ogrn="tender.customers[0].ogrn || tender.customers[0].inn" />
                </template>
                <span v-else>{{tender.customers[0].name}}</span>
            </span>
        </div>
        <div v-if="tender.purchase_sum" class="tender-item__max_price">
            <b>Максимальная цена закупки:</b> <span>{{moneyFormat(tender.purchase_sum, 2)}} <i class="uk-icon-rub"></i></span>
        </div>
        <div v-if="tender.contracts_sum" class="tender-item__price">
            <b>Сумма закупки:</b> <span>{{moneyFormat(tender.contracts_sum, 2)}} <i class="uk-icon-rub"></i></span>
        </div>
        <tenders-lots-list 
            v-if="tender.lots && tender.lots.length" 
            :lotsList="tender.lots" 
            :law="Number(tender.tender_law)"
            :links="links"
        />
    </li>
</template>

<script>
import appAccordion from '@/components/ui/appAccordion/appAccordion.vue'
import cardLink from '@/components/ui/cardLink.vue'
import tooltip from '@/components/ui/tooltip.vue'
import tendersLotsList from '@/components/card/tenders/tendersLotsList.vue'

import { dateParser, moneyFormat } from '@/helpers.ts'

export default {    
    props: {
        tender: {
            type: Object,
            default: {}
        },
        type: {
            type: String,
            default: 'participants'
        }
    },
    components: {
        appAccordion,
        cardLink,
        tooltip,
        tendersLotsList
    },
    data() {
        return {
            links: {
                purchase_number:{
                    223: 'http://zakupki.gov.ru/223/purchase/public/purchase/info/common-info.html?regNumber=',
                    44: 'http://zakupki.gov.ru/epz/order/notice/zk44/view/common-info.html?regNumber=',
                    94: '',
                },
                contract_number:{
                    223: '',
                    44: 'http://zakupki.gov.ru/epz/contract/contractCard/common-info.html?reestrNumber=',
                    94: 'http://zakupki.gov.ru/epz/contract/contractCard/common-info.html?reestrNumber=',
                }
            }
        }
    },
    computed: {
        
    },
    methods: {
        getLink(law, num) {
            return this.links.purchase_number[law] + num
        }
    }
}
</script>

<style lang="sass" scoped>
@import 'styles/global-variables'

.stay-on-row
    display: inline-block

.tender-item
    display: flex
    flex-direction: column
    gap: 10px
    color: #444
    font-family:  Helvetica, Arial, Tahoma, sans-serif
    padding: 25px 0 15px 0
    border-bottom: 1px solid #ddd
    p, ul
        margin: 0
        padding: 0
    
    &__header
        font-size: 20px
        a
            @include pseudo-link
        .grey
            color: #a0a0a0
            font-weight: 700
    &__customers
    .small-list
        padding-left: 30px
        font-size: 13px
        li
            list-style: disc
            margin: 7px 0

</style>